// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brand-premise {
    min-width: 0;
    color: var(--tp-text);
}

.brand-premise h1 {
    max-width: 7ch;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: var(--tp-title-premise);
    font-weight: 900;
    line-height: .98;
    letter-spacing: -.065em;
    word-break: keep-all;
}

.brand-premise h1 > span {
    position: relative;
    display: block;
    padding-right: .08em;
}

.brand-premise-truth {
    color: var(--tp-signal);
}

.brand-premise-truth i {
    position: absolute;
    inset: 14% -.04em 8% -.05em;
    z-index: 1;
    display: block;
    background: var(--tp-mask);
    transform: scaleX(0);
    transform-origin: right center;
    pointer-events: none;
}

.brand-premise p {
    max-width: 26ch;
    margin: 30px 0 0;
    color: var(--tp-muted);
    font-size: 16px;
    line-height: 1.7;
    word-break: keep-all;
}

.brand-premise.compact h1 {
    font-size: var(--tp-title-page);
    line-height: 1.04;
}

.brand-premise.compact p {
    margin-top: 20px;
    font-size: 14px;
}

@media (prefers-reduced-motion: no-preference) {
    .brand-premise-truth i {
        animation: premise-uncover 680ms cubic-bezier(.16, 1, .3, 1) 120ms both;
    }
}

@keyframes premise-uncover {
    0% { transform: scaleX(1); transform-origin: left center; }
    54% { transform: scaleX(1); transform-origin: right center; }
    100% { transform: scaleX(0); transform-origin: right center; }
}

@media (max-width: 767px) {
    .brand-premise h1 {
        max-width: none;
        font-size: var(--tp-title-premise-mobile);
        line-height: 1.01;
    }

    .brand-premise p {
        max-width: 32ch;
        margin-top: 18px;
        font-size: 14px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/public/BrandPremise.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,UAAU;IACV,cAAc;IACd,0BAA0B;IAC1B,oBAAoB;IACpB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI;QACI,uEAAuE;IAC3E;AACJ;;AAEA;IACI,KAAK,oBAAoB,EAAE,6BAA6B,EAAE;IAC1D,MAAM,oBAAoB,EAAE,8BAA8B,EAAE;IAC5D,OAAO,oBAAoB,EAAE,8BAA8B,EAAE;AACjE;;AAEA;IACI;QACI,eAAe;QACf,yCAAyC;QACzC,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,eAAe;IACnB;AACJ","sourcesContent":[".brand-premise {\n    min-width: 0;\n    color: var(--tp-text);\n}\n\n.brand-premise h1 {\n    max-width: 7ch;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    font-size: var(--tp-title-premise);\n    font-weight: 900;\n    line-height: .98;\n    letter-spacing: -.065em;\n    word-break: keep-all;\n}\n\n.brand-premise h1 > span {\n    position: relative;\n    display: block;\n    padding-right: .08em;\n}\n\n.brand-premise-truth {\n    color: var(--tp-signal);\n}\n\n.brand-premise-truth i {\n    position: absolute;\n    inset: 14% -.04em 8% -.05em;\n    z-index: 1;\n    display: block;\n    background: var(--tp-mask);\n    transform: scaleX(0);\n    transform-origin: right center;\n    pointer-events: none;\n}\n\n.brand-premise p {\n    max-width: 26ch;\n    margin: 30px 0 0;\n    color: var(--tp-muted);\n    font-size: 16px;\n    line-height: 1.7;\n    word-break: keep-all;\n}\n\n.brand-premise.compact h1 {\n    font-size: var(--tp-title-page);\n    line-height: 1.04;\n}\n\n.brand-premise.compact p {\n    margin-top: 20px;\n    font-size: 14px;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n    .brand-premise-truth i {\n        animation: premise-uncover 680ms cubic-bezier(.16, 1, .3, 1) 120ms both;\n    }\n}\n\n@keyframes premise-uncover {\n    0% { transform: scaleX(1); transform-origin: left center; }\n    54% { transform: scaleX(1); transform-origin: right center; }\n    100% { transform: scaleX(0); transform-origin: right center; }\n}\n\n@media (max-width: 767px) {\n    .brand-premise h1 {\n        max-width: none;\n        font-size: var(--tp-title-premise-mobile);\n        line-height: 1.01;\n    }\n\n    .brand-premise p {\n        max-width: 32ch;\n        margin-top: 18px;\n        font-size: 14px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
